import { gql } from '@apollo/client';

export const ImportPatientsWithCsv = gql`
  mutation($record: InvitePatientsWithCSVInput!) {
    user {
      patientUser {
        invitePatientsWithCsv(record: $record) {
          ok
          error {
            message
            code
          }
          result {
            taskId
          }
        }
      }
    }
  }
`;

export const LoadPatientsImportStatus = gql`
  query($taskId: ID!) {
    user {
      patient {
        invitePatientsWithCsvStatus(taskId: $taskId) {
          taskId
          taskStatus
          result {
            id
            error
          }
          error
        }
      }
    }
  }
`;
